"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_router_1 = require("react-router");
const react_redux_1 = require("react-redux");
// import _ from 'lodash';
const accounts_1 = require("companion-app-components/flux/accounts");
const mui_1 = require("tss-react/mui");
const styles_1 = require("@mui/material/styles");
const pie_chart_svg_1 = __importDefault(require("assets/zero-state-images/pie-chart.svg"));
const monthlyBarChart_1 = __importDefault(require("containers/Reports/components/monthlyBarChart"));
const LoadingView_1 = __importDefault(require("components/LoadingView"));
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const selectors_1 = require("data/otReports/selectors");
// import { isUnacceptedScheduledTxn } from 'data/transactions/utils';
const utils_1 = require("utils/date/utils");
const core_1 = require("companion-app-components/utils/core");
const helpers_1 = require("../helpers");
const utils_2 = require("../utils");
const styles_2 = __importDefault(require("./styles"));
const useStyles = (0, mui_1.makeStyles)()(styles_2.default);
const SpendingByMonth = () => {
    const { classes } = useStyles();
    const theme = (0, styles_1.useTheme)();
    const navigate = (0, react_router_1.useNavigate)();
    const [selectedMonthIndex, setSelectedMonthIndex] = React.useState(null);
    const hasReportableAccounts = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getHasReportableAccounts(state));
    // TODO: 
    // const showZeroState = window.location.href.indexOf('zeroState') !== -1;
    const dateInterval = React.useMemo(() => (0, utils_1.getPredefinedRange)({ value: '6_MONTHS' }), []);
    const spendingForPeriods = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getSpendingForPeriods)(state, { dateInterval }));
    const navigateToSpendingByMonthWithMonth = (index) => {
        navigate((0, utils_2.getOverTimeReportRoute)(false, index));
    };
    const onBarGraphClick = (indexOfClickedMonth) => {
        setSelectedMonthIndex(indexOfClickedMonth);
        if (indexOfClickedMonth === 0 || indexOfClickedMonth) {
            core_1.tracker.track(core_1.tracker.events.barSelected, { chart: 'spending' });
            setTimeout(() => navigateToSpendingByMonthWithMonth(indexOfClickedMonth), 1000);
        }
        return true;
    };
    const navigateToSpendingByMonth = (e) => {
        e.stopPropagation();
        navigate((0, utils_2.getOverTimeReportRoute)(false));
    };
    // TODO: calculate sum of transaction amounts
    // const sumTransactionAmounts = (transactions) => {    
    //   const array = Array.isArray(transactions) ? transactions : transactions.toArray();
    //   const txns = array.filter((txn) => !isUnacceptedScheduledTxn(txn));
    //   return _.sumBy(txns, (o) => Number(o.amount));
    // };
    const dataIsNull = () => spendingForPeriods === null;
    const dataIsEmpty = () => !dataIsNull() && (0, utils_2.isMonthlyDataEmpty)(spendingForPeriods.periods);
    const view = (0, helpers_1.computeViewState)(dataIsNull, dataIsEmpty, hasReportableAccounts);
    return (<div className={classes.root} onClick={navigateToSpendingByMonth} onKeyPress={navigateToSpendingByMonth} role="presentation">
      {view === 'loading' &&
            <LoadingView_1.default />}
      {view === 'zero' &&
            <ZeroStateView_1.default icon={pie_chart_svg_1.default} size="small" secondary={['Sync your financial institutions to', <br key="br"/>, 'see your spending over time.']}/>}
      {view === 'empty' &&
            <ZeroStateView_1.default size="small" icon={pie_chart_svg_1.default} primary="No Spending" secondary="It looks like you haven't spent any money in the last six months."/>}
      {view === 'main' &&
            <monthlyBarChart_1.default idPrefix="spending" monthlyData={spendingForPeriods.periods} selectedMonthIndex={selectedMonthIndex} active onBarGraphClick={onBarGraphClick || onBarGraphClick} navigateToReports={navigateToSpendingByMonth} tooltipLabel="Spending" getBarAmount={(amount) => -amount} negator={-1} isDashboard colors={{
                    positiveDefault: theme.palette.reports.positiveColor,
                    positiveDimmed: theme.palette.reports.positiveDimmed,
                    negativeDefault: theme.palette.error.main,
                    negativeDimmed: theme.palette.reports.negativeDimmed,
                    tooltipBullet: theme.palette.reports.positiveColor,
                }}/>}
    </div>);
};
exports.default = SpendingByMonth;
